<ng-container *ngIf="userType==='companyManager'">
    <ui-table
    #orderList
    table-title="Gestione Ordini"
>
    <ng-template #customHeader>
        <tr>
            <th>Email</th>
            <th>Data</th>
            <th>Prezzo</th>
            <th>Metodo di pagamento</th>
            <th>Stato</th>
            <th>Dettaglio</th>
            <th>Approva</th>
            <th>Elimina</th>
        </tr>
    </ng-template>
    <ng-template #customRow let-row="row">
        <tr>
            <td>{{ row.address.email }}</td>
            <td>{{ moment(row.createdAt).format('DD-MM-YYYY') }}</td>
            <td class="text-nowrap">{{ row.totalPrice }}&nbsp;€</td>
            <td>{{ paymentTypes(row.paymentMethod) }}</td>
            <td>
                <span class="badge badge-success" *ngIf="row.status === 'paid'">Pagamento effettuato</span>
                <span class="badge badge-warning" *ngIf="row.status === 'pendingCompanyApprovation'">In attesa di approvazione</span>
                <span class="badge badge-warning" *ngIf="row.status === 'verifyingPayment'">Pagamento in fase di verifica</span>
                <span class="badge badge-warning" *ngIf="row.status === 'pendingPayment'">In attesa di pagamento</span>
                <span class="badge badge-success" *ngIf="row.status === 'shipped'">Ordine spedito</span>
                <span class="badge badge-success" *ngIf="row.status === 'delivered'">Ordine consegnato</span>
                <span class="badge badge-error" *ngIf="row.status === 'paymentFailed'">Pagamento fallito</span>
            <td class="text-nowrap">
                <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-1 text-nowrap" (click)="openOrderInfo(row)">
                    <span class="d-none d-sm-inline">Visualizza ordine</span>
                    <span class="d-sm-none">Dettaglio</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill flex-shrink-0" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                    </svg>
                </button>
            </td>
            <td class="text-nowrap">
                <button type="button" class="btn welldone-btn-gray text-nowrap" (click)="approve(row.id)"
                        *ngIf="row.paymentMethod==='transfer' && row.status==='pendingPayment'">
                    <span class="d-none d-md-inline">Approva pagamento</span>
                    <span class="d-md-none">Approva</span>
                </button>
            </td>
            <td>
                <button class="btn welldone-btn-danger" (click)="delete(row.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         class="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                    </svg>
                </button>
            </td>
        </tr>
    </ng-template>
</ui-table>
</ng-container>

<ng-container *ngIf="userType==='user'">
    <ui-table
        #orderList
        table-title="I tuoi Ordini"
    >
        <ng-template #customHeader>
            <tr>
                <th>Email</th>
                <th>Prezzo</th>
                <th>Metodo di pagamento</th>
                <th>Stato</th>
                <th>Dettaglio</th>
            </tr>
        </ng-template>
        <ng-template #customRow let-row="row">
            <tr>
                <td>{{ row.address.email }}</td>
                <td class="text-nowrap">{{ row.totalPrice }}&nbsp;€</td>
                <td>{{ paymentTypes(row.paymentMethod) }}</td>
                <td>
                    <span class="badge badge-success" *ngIf="row.status === 'paid'">Pagamento effettuato</span>
                    <span class="badge badge-warning" *ngIf="row.status === 'pendingCompanyApprovation'">In attesa di approvazione</span>
                    <span class="badge badge-warning" *ngIf="row.status === 'verifyingPayment'">Pagamento in fase di verifica</span>
                    <span class="badge badge-warning" *ngIf="row.status === 'pendingPayment'">In attesa di pagamento</span>
                    <span class="badge badge-success" *ngIf="row.status === 'shipped'">Ordine spedito</span>
                    <span class="badge badge-success" *ngIf="row.status === 'delivered'">Ordine consegnato</span>
                    <span class="badge badge-error" *ngIf="row.status === 'paymentFailed'">Pagamento fallito</span>
                </td>
                <td class="text-nowrap">
                    <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-1 text-nowrap" (click)="openOrderInfo(row)">
                        <span class="d-none d-sm-inline">Dettaglio ordine</span>
                        <span class="d-sm-none">Dettaglio</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill flex-shrink-0" viewBox="0 0 16 16" aria-hidden="true">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                        </svg>
                    </button>
                </td>

            </tr>
        </ng-template>
    </ui-table>
</ng-container>

<ng-container *ngIf="userType==='admin'">
    <ui-table
        #orderList
        table-title="Gestione Ordini (Admin)"
    >
        <ng-template #customHeader>
            <tr>
                <th>Società</th>
                <th>Prezzo</th>
                <th>Metodo di pagamento</th>
                <th>Stato</th>
                <th>Dettaglio</th>
            </tr>
        </ng-template>
        <ng-template #customRow let-row="row">
            <tr>
                <td>{{ row.company.name }}</td>
                <td class="text-nowrap">{{ row.totalPrice }}&nbsp;€</td>
                <td>{{ paymentTypes(row.paymentMethod) }}</td>
                <td>
                    <span class="badge badge-success" *ngIf="row.status === 'paid'">Pagamento effettuato</span>
                    <span class="badge badge-warning" *ngIf="row.status === 'pendingCompanyApprovation'">In attesa di approvazione</span>
                    <span class="badge badge-warning" *ngIf="row.status === 'verifyingPayment'">Pagamento in fase di verifica</span>
                    <span class="badge badge-warning" *ngIf="row.status === 'pendingPayment'">In attesa di pagamento</span>
                    <span class="badge badge-success" *ngIf="row.status === 'shipped'">Ordine spedito</span>
                    <span class="badge badge-success" *ngIf="row.status === 'delivered'">Ordine consegnato</span>
                    <span class="badge badge-error" *ngIf="row.status === 'paymentFailed'">Pagamento fallito</span>
                </td>
                <td class="text-nowrap">
                    <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-1 text-nowrap" (click)="openOrderInfo(row)">
                        <span class="d-none d-sm-inline">Dettaglio ordine</span>
                        <span class="d-sm-none">Dettaglio</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill flex-shrink-0" viewBox="0 0 16 16" aria-hidden="true">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                        </svg>
                    </button>
                </td>
            </tr>
        </ng-template>
    </ui-table>
</ng-container>


<ngx-smart-modal #orderInfoModal identifier="orderInfoModal"
                 (onAnyCloseEvent)="handleOnCloseModal('orderInfoModal')" [closable]="true">
    <ng-container *ngIf="orderInfoModal.hasData()">
        <div class="welldone-card-header">
            <div class="d-flex justify-content-between align-items-center w-100">
                <span>Ordine N°{{orderInfoModal.getData().number}}</span>
                <div class="badge" [ngClass]="{
                    'badge-success': orderInfoModal.getData().status === 'paid' || orderInfoModal.getData().status === 'shipped' || orderInfoModal.getData().status === 'delivered',
                    'badge-warning': orderInfoModal.getData().status === 'pendingCompanyApprovation' || orderInfoModal.getData().status === 'verifyingPayment' || orderInfoModal.getData().status === 'pendingPayment',
                    'badge-error': orderInfoModal.getData().status === 'paymentFailed'
                }">
                    <ng-container *ngIf="orderInfoModal.getData().status === 'paid'">Pagato</ng-container>
                    <ng-container *ngIf="orderInfoModal.getData().status === 'pendingCompanyApprovation'">In attesa approvazione</ng-container>
                    <ng-container *ngIf="orderInfoModal.getData().status === 'verifyingPayment'">Verifica pagamento</ng-container>
                    <ng-container *ngIf="orderInfoModal.getData().status === 'pendingPayment'">In attesa di pagamento</ng-container>
                    <ng-container *ngIf="orderInfoModal.getData().status === 'shipped'">Spedito</ng-container>
                    <ng-container *ngIf="orderInfoModal.getData().status === 'delivered'">Consegnato</ng-container>
                    <ng-container *ngIf="orderInfoModal.getData().status === 'paymentFailed'">Pagamento fallito</ng-container>
                </div>
            </div>
        </div>
        <div class="welldone-card-body bg-light">
            <div class="container-fluid p-0">
                <div class="row g-4">
                    <div class="col-lg-4">
                        <div class="welldone-card mb-4 shadow-sm">
                            <div class="welldone-card-header py-3 fs-6 d-flex align-items-center gap-2">
                                <i class="bi bi-person-circle text-primary"></i> Informazioni Utente
                            </div>
                            <div class="welldone-card-body p-4">
                                <div class="mb-3">
                                    <label class="small text-muted text-uppercase fw-bold d-block mb-1">Nome</label>
                                    <span class="fw-semibold text-dark">{{ orderInfoModal.getData().address.firstName }} {{ orderInfoModal.getData().address.lastName }}</span>
                                </div>
                                <div class="mb-0">
                                    <label class="small text-muted text-uppercase fw-bold d-block mb-1">Email</label>
                                    <span class="text-dark">{{ orderInfoModal.getData().address.email }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="welldone-card shadow-sm" *ngIf="hasPermission('companyVisibility')">
                            <div class="welldone-card-header py-3 fs-6 d-flex align-items-center gap-2">
                                <i class="bi bi-gear-fill text-primary"></i> Gestione Stato
                            </div>
                            <div class="welldone-card-body p-4">
                                <label class="small text-muted text-uppercase fw-bold d-block mb-2">Aggiorna stato ordine</label>
                                <div class="d-flex gap-2 mb-3">
                                    <select class="form-select form-control-solid" [(ngModel)]="selectedStatus">
                                        <option *ngFor="let status of orderStatus" [value]="status.value">{{ status.name }}</option>
                                    </select>
                                    <button class="btn btn-primary" (click)="changeStatus(orderInfoModal.getData().id)" title="Salva stato">
                                        <i class="bi bi-check-lg"></i>
                                    </button>
                                </div>
                                <div class="alert alert-info py-2 px-3 mb-0" style="font-size: 0.75rem; border-radius: 0.5rem;">
                                    <i class="bi bi-info-circle-fill me-1"></i>
                                    Verrà inviata un'email all'utente ad ogni cambio di stato.
                                </div>
                            </div>
                        </div>

                        <div class="welldone-card mt-4 shadow-sm">
                            <div class="welldone-card-header py-3 fs-6 d-flex align-items-center gap-2">
                                <i class="bi bi-credit-card-2-back-fill text-primary"></i> Pagamento
                            </div>
                            <div class="welldone-card-body p-4">
                                <label class="small text-muted text-uppercase fw-bold d-block mb-1">Metodo</label>
                                <span class="text-dark d-block mb-3">{{ paymentTypes(orderInfoModal.getData().paymentMethod) }}</span>
                                
                                <label class="small text-muted text-uppercase fw-bold d-block mb-1">Data ordine</label>
                                <span class="text-dark">{{ moment(orderInfoModal.getData().createdAt).format('DD/MM/YYYY HH:mm') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-8 d-flex flex-column">
                        <div class="welldone-card mb-4 shadow-sm flex-grow-1">
                            <div class="welldone-card-header py-3 fs-6 d-flex align-items-center gap-2">
                                <i class="bi bi-box-seam-fill text-primary"></i> Prodotti in ordine
                            </div>
                            <div class="welldone-card-body p-0 d-block">
                                <div class="table-responsive w-100">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead>
                                            <tr>
                                                <th class="ps-4 text-muted small fw-bold text-uppercase border-bottom-0">Prodotto</th>
                                                <th class="text-muted small fw-bold text-uppercase border-bottom-0">Variante</th>
                                                <th class="text-center text-muted small fw-bold text-uppercase border-bottom-0">Qtà</th>
                                                <th class="text-end pe-4 text-muted small fw-bold text-uppercase border-bottom-0">Prezzo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let barcode of orderInfoModal.getData().orderBarcodes">
                                                <td class="ps-4">
                                                    <div class="d-flex align-items-center gap-3">
                                                        <div class="product-img-wrapper">
                                                            <img [src]="barcode.barcode.product.images && barcode.barcode.product.images[0].imageUrl ? barcode.barcode.product.images[0].imageUrl : 'assets/tshirt.png'" 
                                                                 class="rounded" style="width: 48px; height: 48px; object-fit: cover; border: 1px solid #eee;">
                                                        </div>
                                                        <div>
                                                            <div class="fw-bold text-dark">{{ barcode.barcode.product.name }}</div>
                                                            <div class="small text-muted">SKU: {{ barcode.barcode.barcode }}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span class="badge bg-light text-dark border">{{ barcode.barcode.size.name }}</span>
                                                    <span class="badge bg-light text-dark border ms-1">{{ barcode.barcode.color.name }}</span>
                                                </td>
                                                <td class="text-center fw-bold text-dark">{{ barcode.quantity }}</td>
                                                <td class="text-end pe-4 text-dark fw-semibold">{{ (barcode.barcode.product.fullPrice * barcode.quantity) | currency:'EUR':'symbol':'1.2-2' }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot style="border-top: 2px solid #f1f5f9;">
                                            <tr>
                                                <td colspan="3" class="text-end fw-bold ps-4 py-3">Subtotale Prodotti</td>
                                                <td class="text-end pe-4 py-3 fw-semibold">{{ (orderInfoModal.getData().totalPrice - orderInfoModal.getData().shippingPrice) | currency:'EUR' }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" class="text-end fw-bold ps-4 py-3">Spedizione</td>
                                                <td class="text-end pe-4 py-3 fw-semibold">{{ orderInfoModal.getData().shippingPrice | currency:'EUR' }}</td>
                                            </tr>
                                            <tr class="table-light">
                                                <td colspan="3" class="text-end fw-bold ps-4 py-3">TOTALE ORDINE</td>
                                                <td class="text-end pe-4 py-3 fw-bold text-primary fs-5">{{ orderInfoModal.getData().totalPrice | currency:'EUR'}}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row g-4 flex-shrink-0">
                            <div class="col-md-6">
                                <div class="welldone-card h-100 mb-0 shadow-sm">
                                    <div class="welldone-card-header py-3 fs-6 d-flex align-items-center gap-2">
                                        <i class="bi bi-truck text-primary"></i> Spedizione
                                    </div>
                                    <div class="welldone-card-body p-4">
                                        <div class="badge badge-unknown mb-3">{{ orderInfoModal.getData().shippingType }}</div>
                                        <div class="small text-dark">
                                            <div class="fw-bold fs-6 mb-1">{{ orderInfoModal.getData().address.address }} {{ orderInfoModal.getData().address.addressOptional }}</div>
                                            <div>{{ orderInfoModal.getData().address.zip }} {{ orderInfoModal.getData().address.city }} ({{ orderInfoModal.getData().address.province }})</div>
                                            <div class="mt-3 d-flex align-items-center gap-2 text-primary fw-bold">
                                                <i class="bi bi-cash"></i> Costo: {{ orderInfoModal.getData().shippingPrice | currency:'EUR' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="welldone-card h-100 mb-0 shadow-sm">
                                    <div class="welldone-card-header py-3 fs-6 d-flex align-items-center gap-2">
                                        <i class="bi bi-file-earmark-text text-primary"></i> Fatturazione
                                    </div>
                                    <div class="welldone-card-body p-4">
                                        <div class="small text-dark">
                                            <div class="fw-bold fs-6 mb-1">{{ orderInfoModal.getData().address.legalFirstName }} {{ orderInfoModal.getData().address.legalLastName }}</div>
                                            <ng-container *ngIf="orderInfoModal.getData().address.businessName">
                                                <div class="fw-bold text-muted">{{ orderInfoModal.getData().address.businessName }}</div>
                                                <div class="mt-2 mb-2 p-2 bg-light rounded">
                                                    <div><span class="text-muted small fw-bold">P.IVA:</span> {{ orderInfoModal.getData().address.vat }}</div>
                                                    <div><span class="text-muted small fw-bold">SDI:</span> {{ orderInfoModal.getData().address.sdi }}</div>
                                                    <div><span class="text-muted small fw-bold">PEC:</span> {{ orderInfoModal.getData().address.pec }}</div>
                                                </div>
                                            </ng-container>
                                            <div class="mt-2">
                                                <div class="text-muted small fw-bold">Indirizzo Legale:</div>
                                                <div>{{ orderInfoModal.getData().address.legalAddress }}</div>
                                                <div>{{ orderInfoModal.getData().address.legalZip }} {{ orderInfoModal.getData().address.legalCity }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="welldone-card-footer">
            <button class="btn btn-secondary px-4" (click)="orderInfoModal.close()">Chiudi</button>
        </div>
    </ng-container>
</ngx-smart-modal>

